export const queryDetailsSteps = [
    {
      element: ".FoterDetailContainer",
      intro: `
          <h3>Parent Features Bottom Pane</h3>
          <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".Engagement",
      intro: `
          <h3>Engagement</h3>
          <p>Engagement has 2 features (as shown in left most pane):
         </p>
         <ol>
            <li>Community</li>
            <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneE",
      intro: `
          <h3>Features Group Left Pane
          Engagement has 2 features as shown:</h3>
          <ol>
          <li>Community</li>
          <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".query",
      intro: `
          <h3>Query</h3>
          <p>Currently 'Query' feature is selected, Let's navigate through this feature</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
        element: ".query_channelName",
        intro: `
            <h3>Query Group name</h3>
            <p>This is current Query group name</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".status_box",
        intro: `
            <h3>Query Status Box</h3>
            <p>Each Query group can have multiple queries, Queries can be in any 4 states - Active, Pending, Resolved and Declined. You can select Queries on any desired specific state.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".main_box",
        intro: `
            <h3>Query list</h3>
            <p>Here the list of queries will be displayed.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },{
        element: ".tagList",
        intro: `
            <h3>Tag list</h3>
            <p>You can see tags associated with the queries.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".current_query",
        intro: `
            <h3>Query date</h3>
            <p>All queries will be grouped under respective dates.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".full_box_coleps",
        intro: `
            <h3>Query detail</h3>
            <p>You can see query details, having query status, book, chapter details etc.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".creaeQueryBtn",
        intro: `
            <h3>Create queries</h3>
            <p>1. Crested query will be in Pending' status and be only shown to you.*</p>
<p>2. Query will move to Active state after review by Moderator and will get Visible to your Peers.</p>
<p>3. However, If Moderator rejects your created Query it will show as Declined' state which you can Edit to Post again or Delete it </p>
<p>4. One can put Reply or do Like over any query in Active' state by clicking over such query</p>
<p>5. You can resolve your active queries if your query is solved. Such query will be shown in Resolved' state.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]